export const daysColor = (days) => {
  if (days == null) return "bg-slate-100 text-slate-500"
  if (days <= 3) return "bg-red-100 text-red-600"
  if (days <= 7) return "bg-orange-100 text-orange-600"
  return "bg-emerald-100 text-emerald-700"
}
